'use strict';

class Workout{
    date = new Date();
    id = (Date.now() + "").slice(-10);
    clicks = 0;

    constructor(coords, distance, duration){
        this.coords = coords; // [lat,lng]
        this.distance = distance; // in km
        this.duration = duration; // in min
    }

    _setDescription(){
        // prettier-ignore
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 
        'August', 'September', 'October', 'November', 'December'];

        this.description = `${this.type[0].toUpperCase()}${this.type.slice(1)} on ${months[this.date.getMonth()]} ${this.date.getDate()}`;
    }
    
    click(){
        this.clicks++;
    }
}

class Running extends Workout{
    type = "running";
    constructor(coords, distance, duration, cadence){
        super(coords, distance, duration);
        this.cadence = cadence;
        this.calcPace();
        this._setDescription();
    }
    calcPace(){
        // min/km
        this.pace = this.duration/this.distance;
       return this.pace; 
    }
}

class Cycling extends Workout{
    type = "cycling";
    constructor(coords, distance, duration, elevationGain){
        super(coords, distance, duration);
        this.elevationGain = elevationGain;
        this.calcSpeed();
        this._setDescription();
    }
    calcSpeed(){
     // km/h
     this.speed = this.distance/ (this.duration/60); 
     return this.speed;
    }
}

//////////////////////////////////
//Application Architecture

const form = document.querySelector('.form');
const containerWorkouts = document.querySelector('.workouts');
const inputType = document.querySelector('.form__input--type');
const inputDistance = document.querySelector('.form__input--distance');
const inputDuration = document.querySelector('.form__input--duration');
const inputCadence = document.querySelector('.form__input--cadence');
const inputElevation = document.querySelector('.form__input--elevation');


class App{
    #map;
    #mapZoomLevel = 13;
    #mapEvent;
    #workouts = [];

    constructor(){
     // Get user's position   
     this._getCurrentPosition();

     // Get data from local storage
     this._getLocalStorage();

     //Attach event handlers
     form.addEventListener("submit", this._newWorkout.bind(this));

    inputType.addEventListener("change", this._toggleElevationField);
    
    containerWorkouts.addEventListener("click", this._moveToPopup.bind(this));
    }

    _getCurrentPosition(){
        if(navigator.geolocation)
        navigator.geolocation.getCurrentPosition(this._loadMap.bind(this),
              function(){
                  alert("Request failed");
            });
        }
        
    _loadMap(position){  
     const {latitude, longitude} = position.coords;

     let coords = [latitude, longitude]; 
     this.#map = L.map('map').setView(coords, this.#mapZoomLevel);

     L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
     }).addTo(this.#map);

     this.#map.on("click", this._showForm.bind(this));

     this.#workouts.forEach(work => {
        this._renderWorkoutMarker(work);
       })
    }

    _showForm(mapE){
        this.#mapEvent = mapE;
        form.classList.remove("hidden");
        inputDistance.focus();
    }

    _hideForm(){
     //Empty Inputs
     inputDistance.value = inputCadence.value = inputDuration.value = inputElevation.value  =  "";
     form.style.display = "none";
     form.classList.add('hidden');
     setTimeout(() => (form.style.display = "grid"), 1000);
    }

    _toggleElevationField(){
        inputElevation.closest(".form__row")
        .classList.toggle("form__row--hidden");

        inputCadence.closest(".form__row")
        .classList.toggle("form__row--hidden");
   
    }

    _newWorkout(e){
    
    const validInput = (...inputs) => 
      inputs.every(inp => Number.isFinite(inp));   
         
    const allPositive = (...inputs) => 
      inputs.every(inp => inp > 0); 
      
     e.preventDefault();

    //Get data from form
    const type = inputType.value;
    const distance = +inputDistance.value;
    const duration = +inputDuration.value;
    const {lat, lng} = this.#mapEvent.latlng;
    let workout;

    //If workout running, create running object
    if(type === "running"){
        const cadence = +inputCadence.value;

        //Check if data is valid
        if(
            // !Number.isFinite(distance)||
            // !Number.isFinite(duration)||
            // !Number.isFinite(cadence)
            !validInput(distance, duration, cadence) || 
            !allPositive(distance,duration,cadence)
         )
         return alert("Inputs have to br positive numbers");

         workout = new Running([lat,lng], distance, duration, cadence);
    }

    //If workout cycling, create cycling object

    if(type === "cycling"){
        const elevation = +inputElevation.value;
        //Check if data is valid
        if(
            // !Number.isFinite(distance)||
            // !Number.isFinite(duration)||
            // !Number.isFinite(elevation)
            !validInput(distance, duration, elevation) || 
            !allPositive(distance, duration)
         )
         return alert("Inputs have to br positive numbers");

         workout = new Cycling([lat,lng], distance, duration, elevation);
    }

    //Add new object to workouts array
    this.#workouts.push(workout);
    // console.log(this.#workouts);s

    //Render workout on map as marker
    this._renderWorkoutMarker(workout);   

    //Render workout on list
    this._renderWorkout(workout);

     //Hide form + Clear input fields
     this._hideForm();

     //Set local storage to all workout
     this._setLocalStorage();
    }

    _renderWorkoutMarker(workout){

     //Display maker
     L.marker(workout.coords)
     .addTo(this.#map)
     .bindPopup(
     L.popup({
     maxWidth: 250,
     minWidth: 100,
     autoClose: false,
     closeOnClick: false,
     className: `${workout.type}-popup`
     })
     )
     .setPopupContent(`${workout.type === "running" ? '🏃‍♂️' : '🚴‍♂️'} ${workout.description}`)
     .openPopup();
    }

    _renderWorkout(workout){
        let html = `
        <li class="workout workout--${workout.type}" data-id="${workout.id}">
        <h2 class="workout__title">${workout.description}</h2>
        <div class="workout__details">
          <span class="workout__icon">${
            workout.type === "running" ? '🏃‍♂️' : '🚴‍♂️'
        }</span>
          <span class="workout__value">${workout.distance}</span>
          <span class="workout__unit">km</span>
        </div>
        <div class="workout__details">
          <span class="workout__icon">⏱</span>
          <span class="workout__value">${workout.duration}</span>
          <span class="workout__unit">min</span>
        </div>`;

        if(workout.type === "running")
          html += `
          <div class="workout__details">
           <span class="workout__icon">⚡️</span>
           <span class="workout__value">${workout.pace.toFixed(1)}</span>
           <span class="workout__unit">min/km</span>
          </div>
          <div class="workout__details">
           <span class="workout__icon">🦶🏼</span>
           <span class="workout__value">${workout.cadence}</span>
           <span class="workout__unit">spm</span>
          </div>
          </li>
          `

        if(workout.type === "cycling")
          html += `
          <div class="workout__details">
           <span class="workout__icon">⚡️</span>
           <span class="workout__value">${workout.speed.toFixed(1)}</span>
           <span class="workout__unit">km/h</span>
          </div>
          <div class="workout__details">
           <span class="workout__icon">⛰</span>
           <span class="workout__value">${workout.elevationGain}</span>
           <span class="workout__unit">m</span>
          </div>
         </li>
          `;

        form.insertAdjacentHTML("afterend", html);
    };

    _moveToPopup(e){
        const workoutEl = e.target.closest(".workout");
        if(!workoutEl) return;
        const workout = this.#workouts.find(el => el.id === workoutEl.dataset.id);

       this.#map.setView(workout.coords, this.#mapZoomLevel, {
        // To give jumping effect from one location to another
        animate: true,
        pan: {
            //Time taken to move from one location to another
            duration: 1,
        }
       });

       //using the public interface
    //    workout.click();
    }

    _setLocalStorage(){
        localStorage.setItem("workouts", JSON.stringify(this.#workouts));

    }

    _getLocalStorage(){
       const data = JSON.parse(localStorage.getItem("workouts"));

       if(!data) return;

       this.#workouts = data;

       this.#workouts.forEach(work => {
        this._renderWorkout(work);
       })
    };

    //Call this metohd in console as app.reset() to delete all the data from localStorage
    reset(){
        localStorage.removeItem("workouts");
    }

};

const app = new App();





















